<template>
  <div>
    <b-row class="d-flex justify-content-end" align="right">
      <div class="mx-2">
        <b-form-group
          label="Status"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <div
            :class="itemRowBackground(this.detail.status)"
            size="sm"
            disabled
            class="px-2"
            style="width: fit-content;"
          >
            {{ this.detail.status }}
          </div>
        </b-form-group>
      </div>
      <div
        v-if="canOpenSummary && detail.bup_summary_id"
        class="summary border-left pl-3 pr-5"
      >
        <a :href="`/bup-summary/${detail.bup_summary_id}/detail`">
          <b>See Summary BUP</b>
        </a>
      </div>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contractor Name"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contractor_name"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col>
        <validation-provider
          :rules="isSubmit ? 'required' : ''"
          name="Invoice Number"
          v-slot="{ errors }"
          slim
        >
          <b-form-group
            label="Invoice Number"
            label-size="sm"
            label-class="font-weight-bold"
            :invalid-feedback="errors[0]"
          >
            <b-form-input
              ref="input"
              autocapitalize="off"
              v-model="detail.invoice_number"
              :disabled="detail.approval_status ? !detail.approval_status.isEdit : !(detail.status === 'Draft')"
              :class="{ 'is-invalid': errors.length }"
            />
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Contract Number"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="detail.contract_number"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group
          label="Payment Period"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-input-group>
            <b-form-input
              :value="formatDate(detail.payment_period_start)"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                disabled
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="" label-size="sm" label-class="font-weight-bold">
          <br />
          <b-input-group>
            <b-form-input
              :value="formatDate(detail.payment_period_end)"
              type="text"
              placeholder="-"
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                button-only
                left
                locale="en-US"
                size="sm"
                aria-controls="example-input"
                disabled
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import { hasPermission } from '@/utils/permissions'
import { SUMMARY_VIEW } from '@/fixtures'

export default {
  props: {
    detail: {
      types: Object,
      default: () => ({
        contractor_name: '',
        contract_number: '',
        wo_number: '',
        budget_code: ''
      })
    },
    isSubmit: {
      types: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      canOpenSummary: hasPermission(SUMMARY_VIEW)
    }
  },
  methods: {
    itemRowBackground(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY')
    }
  }
}
</script>

<style scoped>

.summary {
  color: #737AF1;
  font-size: 12px;
  height: 30px;
  text-align: center;
  margin-top: 23px;
}

</style>
